import { Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps 
{
    text?: string;
    onClick: ()=>void;
}

const CreateButton: FC<IProps> = ({ text, onClick }) => 
{
    const { t } = useTranslation();

    return (<Button 
        color="primary"
        onClick={onClick}
    >
        {text ?? t('buttons.create')}
    </Button>);
};

export default CreateButton;